;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	environmentManager,
	keepPreviousData,
	queryOptions,
} from "@tanstack/react-query";
import {
	queryFetcher,
	type RequestOptions,
} from "@/queries/config/query-fetcher";
import { userQueryKeys } from "@/queries/query-keys/user";
import type { UserDataResponse, UserSettingsResponse } from "@/types/user";

/**
 * Fetches a user by their ID
 * @param userId - The ID of the user to fetch
 * @returns The user data
 */
export async function getUser(
	userId: string,
	options?: RequestOptions,
): Promise<UserDataResponse> {
	const url = environmentManager.isServer()
		? `${process.env.NEXT_PUBLIC_APP_URL}/api/users/${userId}`
		: `/api/users/${userId}`;

	return queryFetcher(url, {
		...options,
		method: "GET",
	});
}

/**
 * Fetches the settings of a user
 * @param options - Request Options
 * @returns
 */
export async function getUserSettings(
	options?: RequestOptions,
): Promise<UserSettingsResponse> {
	return queryFetcher("/api/users/settings", {
		...options,
		method: "GET",
	});
}

/** ---- Functions with query options ---- */
/**
 * Returns a queryOptions object for the getUser function
 * @param userId - The ID of the user to get
 * @returns A queryOptions object
 */
export const getUserQueryOptions = (userId?: string) => {
	return queryOptions({
		enabled: !!userId,
		// userId already exists here, so we can safely cast to string
		queryFn: () => getUser(userId as string),
		queryKey: userQueryKeys.detail(userId),
		retry: 1,
	});
};

export const getUserSettingsQueryOptions = () => {
	return queryOptions({
		placeholderData: keepPreviousData,
		queryFn: getUserSettings,
		queryKey: userQueryKeys.settings(),
		retry: 1,
	});
};

/** @deprecated Use only from the Leaderboard `useAutoSync` caller. */
export async function generalSync(options?: RequestOptions): Promise<void> {
	const url = environmentManager.isServer()
		? `${process.env.NEXT_PUBLIC_APP_URL}/api/workspaces/auto-sync`
		: "/api/workspaces/auto-sync";

	return queryFetcher(url, {
		...options,
		method: "POST",
	});
}
